// ⚠️ TEMP DEV-PHASE PREVIEW — NOT production data.
// `suppliers/search` is services-only today, so the store and restaurant tabs
// have nothing real to show until the backend half lands. This stands in for
// all three tabs while the page is being reviewed, and comes out with the
// preview seed.

export const isSupplierIndexPreview = () => {
  try {
    const param = new URLSearchParams(window.location.search).get("preview");
    if (param === "1") localStorage.setItem("supplierIndexPreview", "1");
    if (param === "0") localStorage.removeItem("supplierIndexPreview");
    return localStorage.getItem("supplierIndexPreview") === "1";
  } catch {
    return false;
  }
};

// Images that already ship with the app, so the sample cards look like cards
// rather than like broken ones.
const PREVIEW_IMAGES = [
  "/mysupplier.png",
  "/supplier-icon.png",
  "/people.png",
  "/profile.png",
  "/avataar.png",
];

const supplier = (id, name, business, location, categories, itemTypes, communityStatus = null) => ({
  id,
  full_name: name,
  business_nickname: business,
  display_image_url: PREVIEW_IMAGES[id % PREVIEW_IMAGES.length],
  location,
  main_categories: categories.map((name) => ({ name })),
  item_types: itemTypes,
  community_status: communityStatus,
});

export const PREVIEW_SUPPLIERS = {
  service: [
    supplier(9001, "אבי מזרחי", "אבי חשמל ותאורה", "כפר סבא", ["Electricity", "Lighting"], ["service"]),
    supplier(9003, "משה כהן", "כהן אינסטלציה", "הוד השרון", ["Plumbing"], ["service"]),
    supplier(9004, "יעל אדרי", "סטודיו יעל — צילום אירועים", "תל אביב", ["Photography"], ["service"]),
  ],
  product: [
    supplier(9101, "דנה לוי", "מכולת השכונה", "כפר סבא", ["Groceries"], ["product"]),
    // Already the community's cleaner, so she shows up only here — as a known supplier.
    supplier(9102, "רונית בר", "רונית — חנות מוצרי ניקיון", "רעננה", ["Home & Cleaning"], ["service", "product"], "active"),
    supplier(9103, "עומר שגב", "פרחי עומר", "הרצליה", ["Flowers"], ["product", "restaurant"]),
  ],
  restaurant: [
    supplier(9201, "סמי חדד", "מסעדת סמי — מטבח ביתי", "כפר סבא", ["Home cooking"], ["restaurant"]),
    supplier(9202, "עומר שגב", "בית קפה עומר", "הרצליה", ["Cafe"], ["product", "restaurant"]),
  ],
};

export const PREVIEW_COUNTS = {
  service: PREVIEW_SUPPLIERS.service.length,
  product: PREVIEW_SUPPLIERS.product.length,
  restaurant: PREVIEW_SUPPLIERS.restaurant.length,
};

// One shallow tree per catalog, in the shape the filter dropdown expects.
export const PREVIEW_CATEGORIES = {
  service: [
    { id: 1, name: "Home", display_order: 1, sub_categories: [
      { id: 11, name: "Electricity", display_order: 1 },
      { id: 12, name: "Plumbing", display_order: 2 },
      { id: 13, name: "Cleaning", display_order: 3 },
    ] },
    { id: 2, name: "Events", display_order: 2, sub_categories: [
      { id: 21, name: "Photography", display_order: 1 },
    ] },
  ],
  product: [
    { id: 3, name: "Food & Groceries", display_order: 1, sub_categories: [
      { id: 31, name: "Groceries", display_order: 1 },
      { id: 32, name: "Bakery", display_order: 2 },
    ] },
    { id: 4, name: "Home", display_order: 2, sub_categories: [
      { id: 41, name: "Home & Cleaning", display_order: 1 },
      { id: 42, name: "Flowers", display_order: 2 },
    ] },
  ],
  restaurant: [
    { id: 5, name: "Kitchens", display_order: 1, sub_categories: [
      { id: 51, name: "Home cooking", display_order: 1 },
      { id: 52, name: "Cafe", display_order: 2 },
    ] },
  ],
};

/**
 * Applies the tab's own filters to the sample data, so the preview behaves
 * like the real thing — including landing on the empty state when a filter
 * matches nothing.
 */
export const filterPreviewSuppliers = (itemType, { searchValue, selectedCategories }) => {
  const rows = PREVIEW_SUPPLIERS[itemType] || [];
  const term = (searchValue || "").trim().toLowerCase();
  const names = (selectedCategories || [])
    .map((id) =>
      (PREVIEW_CATEGORIES[itemType] || [])
        .flatMap((group) => group.sub_categories || [])
        .find((sub) => String(sub.id) === String(id))?.name,
    )
    .filter(Boolean);

  return rows.filter((row) => {
    const matchesTerm =
      !term ||
      `${row.full_name} ${row.business_nickname}`.toLowerCase().includes(term);
    const matchesCategory =
      names.length === 0 ||
      row.main_categories.some((category) => names.includes(category.name));
    return matchesTerm && matchesCategory;
  });
};
